import {createSelector} from 'reselect'

export let useStatusDateSelector = state => (
  state.settings && state.settings.look_ahead_use_status_date
)




// WEBPACK FOOTER //
// ./src/selectors/settings.js